// PageLayoutProvider.js
// Provides page-level metadata (title, subtitle, buttons, paths/breadcrumbs)
// to the shell via React Context. Pages set metadata by calling
// setPageInfo() from TitleBar's useEffect — no JSX change required in pages.

import React, { createContext, useContext, useState, useCallback } from 'react'

const PageLayoutContext = createContext({
  pageInfo: null,
  setPageInfo: () => {},
})

export function PageLayoutProvider({ children }) {
  const [pageInfo, setPageInfoState] = useState(null)

  const setPageInfo = useCallback((info) => {
    setPageInfoState(info)
  }, [])

  return (
    <PageLayoutContext.Provider value={{ pageInfo, setPageInfo }}>
      {children}
    </PageLayoutContext.Provider>
  )
}

// usePageLayout() — consumed by TitleBar (to push info) and PageHeader (to read info).
export function usePageLayout() {
  return useContext(PageLayoutContext)
}

export default PageLayoutProvider
